import {observer} from "mobx-react";
import {Box, useMediaQuery, useTheme} from "@mui/material";
import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import {Pagination, Autoplay} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import './HomeSlideshow.css'
import p1 from '../../../assets/img/highRes/fixer.webp'
import p2 from '../../../assets/img/highRes/boats.webp'
import p3 from '../../../assets/img/highRes/akordeon_trio-1350.webp'
import p4 from '../../../assets/img/highRes/foto (17).webp'
import p5 from '../../../assets/img/highRes/KAREN TWEED 2 by Tom OBrien.webp'
import p6 from '../../../assets/img/highRes/PIGINI_75-¦-168-Modifica.webp'
import p7 from '../../../assets/img/highRes/Rafal Luc.webp'
import p8 from '../../../assets/img/highRes/36.webp'
import p9 from '../../../assets/img/highRes/DSC_0328.webp'
import p10 from '../../../assets/img/highRes/34.webp'
import p11 from '../../../assets/img/highRes/IMG_4854.webp'


const images: string[] = [p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11];
const verticalOffsetsSm = [ '0%',  '0%',  '0%',  '0%',  '0%',  '0%',  '0%', '0%', '0%', '0%', '0%'];
const verticalOffsetsLg = ['10%', '70%', '20%', '10%', '22%', '25%', '40%', '10%', '10%', '45%', '35%'];

export default observer(function HomeSlideshow() {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

    const currentOffsets = isLargeScreen ? verticalOffsetsLg : verticalOffsetsSm;
    return (
        <Box sx={{height: 500}}>
            <Swiper
                autoplay={{
                    delay: 10000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                    stopOnLastSlide: false,
                }}
                pagination={true}
                modules={[Pagination, Autoplay]}
                className={"home-swiper"}
            >
                {
                    images.map((image, key) =>
                        <SwiperSlide key={key} >
                            <img 
                                src={image} 
                                alt={'image'}
                                style={{
                                    objectFit: 'cover',
                                    objectPosition: `center ${currentOffsets[key]}` // Apply the vertical offset
                                }} 
                            />
                        </SwiperSlide>
                    )
                }
            </Swiper>
        </Box>
    )
})